import moment from "moment";

export type CrmBoardTemplateId = "blank" | "renewals";

export interface CrmBoardListTemplate {
  name: string;
  percentage: number;
  addToProbability: boolean;
}

export interface CrmBoardTemplateDefinition {
  id: CrmBoardTemplateId;
  nameKey: string;
  descriptionKey: string;
  defaultBoardNameKey: string;
  buildLists: (locale?: string) => CrmBoardListTemplate[];
}

const MONTHS_BY_LOCALE: Record<string, string[]> = {
  es: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ],
  en: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  pt: [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ],
};

const resolveMonthNames = (locale?: string): string[] => {
  const language = (locale || "es").split("-")[0].toLowerCase();
  if (MONTHS_BY_LOCALE[language]) {
    return MONTHS_BY_LOCALE[language];
  }

  return Array.from({ length: 12 }, (_, index) =>
    moment().locale(locale || "es").month(index).format("MMMM")
  );
};

const buildMonthLists = (locale?: string): CrmBoardListTemplate[] =>
  resolveMonthNames(locale).map((name) => ({
    name,
    percentage: 100,
    addToProbability: true,
  }));

export const CRM_BOARD_TEMPLATES: CrmBoardTemplateDefinition[] = [
  {
    id: "blank",
    nameKey: "app.crmBusiness.template.blank.name",
    descriptionKey: "app.crmBusiness.template.blank.description",
    defaultBoardNameKey: "app.crmBusiness.template.blank.defaultName",
    buildLists: () => [],
  },
  {
    id: "renewals",
    nameKey: "app.crmBusiness.template.renewals.name",
    descriptionKey: "app.crmBusiness.template.renewals.description",
    defaultBoardNameKey: "app.crmBusiness.template.renewals.defaultName",
    buildLists: buildMonthLists,
  },
];

export const getCrmBoardTemplate = (id: CrmBoardTemplateId) =>
  CRM_BOARD_TEMPLATES.find((template) => template.id === id) ??
  CRM_BOARD_TEMPLATES[0];
